var _excluded = ["image", "title", "button", "secondButton"],
  _excluded2 = ["text"],
  _excluded3 = ["text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import Picture from "../../quarks/Picture";
import { HoverContainer, StyledButtonAtm, TextAtmWrapper, StyledFlexContainerOrg, SecondButtonWrapper, StyledRelativeContainerOrg, StyledTextAtm } from "./TemplateMiniatureMol.styled";
function TemplateMiniatureMol(_ref) {
  var image = _ref.image,
    title = _ref.title,
    button = _ref.button,
    secondButton = _ref.secondButton,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var buttonText = button.text,
    restButtonProps = _objectWithoutProperties(button, _excluded2);
  var secondButtonText = null;
  var restSecondButtonProps;
  if (secondButton) {
    var text = secondButton.text,
      restObjectProps = _objectWithoutProperties(secondButton, _excluded3);
    secondButtonText = text;
    restSecondButtonProps = restObjectProps;
  }
  return /*#__PURE__*/React.createElement(StyledFlexContainerOrg, _extends({
    direction: "column"
  }, restProps), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledRelativeContainerOrg, null, /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  }), /*#__PURE__*/React.createElement(HoverContainer, null, /*#__PURE__*/React.createElement(StyledButtonAtm, _extends({
    color: "white",
    size: "small"
  }, restButtonProps), buttonText), /*#__PURE__*/React.createElement(StyledButtonAtm, _extends({
    color: "dark",
    size: "small",
    $isMobile: true
  }, restButtonProps), buttonText), secondButton && secondButtonText && restSecondButtonProps ? /*#__PURE__*/React.createElement(SecondButtonWrapper, {
    topSpace: 1.5
  }, /*#__PURE__*/React.createElement(StyledButtonAtm, _extends({
    color: "white",
    size: "small",
    variant: "outlined"
  }, restSecondButtonProps), secondButtonText), /*#__PURE__*/React.createElement(StyledButtonAtm, _extends({
    color: "dark",
    size: "small",
    $isMobile: true,
    variant: "outlined"
  }, restSecondButtonProps), secondButtonText)) : null))), /*#__PURE__*/React.createElement(TextAtmWrapper, {
    topSpace: 3
  }, /*#__PURE__*/React.createElement(StyledTextAtm, {
    typography: "big1"
  }, title)));
}
export default TemplateMiniatureMol;